<!-- 发展历程 -->
<template>
    <div class='developmentHistory'>
        <div class="banner">
            <img src="../../assets/aboutUs/developmentHistory/发展历程banner.jpg" alt="">
            <div class="tip">
                <div class="title">探见大事记</div>
                <div class="En">
                    <p>GROUP</p>
                    <p>MEMORABILIA</p>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="con-warp">
                <div class="item">
                    <img src="../../assets/aboutUs/developmentHistory/立.jpg" alt="">
                    <div class="center-line"></div>
                    <div class="right-con">
                        <div class="title">2019 己亥</div>
                        <div class="line-warp">
                            <div class="yuan"></div>
                            <div class="line"></div>
                        </div>
                        <p class="text">
                            <strong>初心</strong>&nbsp; 抱持着“守护生活守护爱”的初心，探见科技在上海成立，开局即组建了建筑装饰领域的“梦之队”，将社会责任融入战略决策。
                        </p>
                        <p class="text">
                            <strong>谋定</strong> &nbsp;从情怀到实践是惊险一跃，坚守向上向善的经营准则，坚守商业道德保持战略定力，在业务主航道上稳健前行，保护客户、员工、股东权益。
                        </p>
                    </div>
                </div>
                <div class="item">
                    <img src="../../assets/aboutUs/developmentHistory/起.jpg" alt="">
                    <div class="center-line"></div>
                    <div class="right-con">
                        <div class="title">2020 庚子</div>
                        <div class="line-warp">
                            <div class="yuan"></div>
                            <div class="line"></div>
                        </div>
                        <p class="text">
                            <strong>恒心</strong>&nbsp;
                            庚子，大疫三年的开端。探见是大家的，依赖大家的，服务大家的，我们有实力有担当守护好最宝贵的财富--人才。不减薪不裁员，做好后勤，照顾好所有员工和他们的家庭。有恒产者有恒心，有恒心才可交心。
                        </p>
                        <p class="text">
                            <strong>数据治理体系</strong>&nbsp; 采用远程工具等数字手段解决疫情带来的办公问题，结合配套制度提升组织敏捷性，规划数据治理体系，聚焦核心产品，增加渠道多样性。
                        </p>
                    </div>
                </div>
                <div class="item">
                    <img src="../../assets/aboutUs/developmentHistory/奋.jpg" alt="">
                    <div class="center-line"></div>
                    <div class="right-con">
                        <div class="title">2021辛丑</div>
                        <div class="line-warp">
                            <div class="yuan"></div>
                            <div class="line"></div>
                        </div>
                        <p class="text">
                            <strong>“十四五”开局之年</strong>&nbsp;
                            中国GDP增速8.4，而房企杠杆激进扩张时代结束，普遍加速缩表进程，行业转入风险出清周期的开端。矛盾中，探见科技产品化和产品商业化的加速发展给我们带来了超预期的惊喜。
                        </p>
                        <p class="text">
                            <strong> 守住根本</strong>&nbsp; 调整团队到最佳状态，密切关注人才市场波动和变化，提升人才密度。由道入术，在宏观方向和微观业务两个层面，为客户提供系统性的理论框架。
                        </p>
                    </div>
                </div>
                <div class="item">
                    <img src="../../assets/aboutUs/developmentHistory/仁.jpg" alt="">
                    <div class="center-line"></div>
                    <div class="right-con">
                        <div class="title">2022壬寅</div>
                        <div class="line-warp">
                            <div class="yuan"></div>
                            <div class="line"></div>
                        </div>
                        <p class="text">
                            <strong>读书会</strong>&nbsp;
                            探见汇集了背景迥异、各擅其强的科学家、企业家、专家、职业经理人，通过发起读书会实现兵种协同、文化高度统一，共读共学中，形成一个“一致行动人”多维度的实体。
                        </p>
                        <p class="text">
                            <strong>变局中开新局</strong>&nbsp;
                            探见强化战略定力，在业务主航道上做深做精，连年在各业门窗、幕墙、精装修等业务板块取得不动产供应链竞争力十强、房建供应链综合实力TOP500等实力大奖，并成为中国房地产协会会员单位。
                        </p>
                    </div>
                </div>
                <div class="item">
                    <img src="../../assets/aboutUs/developmentHistory/韧.jpg" alt="">
                    <div class="center-line"></div>
                    <div class="right-con">
                        <div class="title">2023癸卯</div>
                        <div class="line-warp">
                            <div class="yuan"></div>
                            <div class="line"></div>
                        </div>
                        <p class="text">
                            <strong>绿色建筑</strong>&nbsp;
                            G60科创之眼项目中，有一栋绿色建筑示范楼，通过建筑物废弃、劳动力、生产制造和建筑装备等核心要素的横向融合，以及上游标准设计、建造、运维等产业节点的纵向拉伸，探见将产业化、数字化、智能化、低碳化的绿色实践融入建筑全生命周期。
                            庚子，大疫三年的开端。探见是大家的，依赖大家的，服务大家的，我们有实力有担当守护好最宝贵的财富--人才。不减薪不裁员，做好后勤，照顾好所有员工和他们的家庭。有恒产者有恒心，有恒心才可交心。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.developmentHistory {
    width: 100%;

    .banner {
        width: 100%;
        height: calc(100vh - 48px);
        background-color: #999;
        margin-bottom: 20px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        .tip {
            position: absolute;
            bottom: 86px;
            right: 135px;
            width: 410px;
            height: 188px;
            background-color: rgb(35, 44, 223);
            border-radius: 12px;

            .title {
                text-align: left;
                font-size: 34px;
                color: #fff;
                margin: 50px 0 6px 50px;
            }

            .En {
                margin-left: 50px;

                p {
                    color: #fff;
                }
            }
        }
    }

    .main {
        width: 1200px;
        margin: 0 auto;

        .con-warp {
            position: relative;
            padding-top: 100px;

            &::before {
                position: absolute;
                top: 0;
                left: 556px;
                z-index: -1;
                content: ' ';
                display: block;
                width: 2px;
                height: 100%;
                background-color: rgb(228, 228, 228);
            }

            .item {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 100px;

                img {
                    width: 390px;
                    height: 390px;
                    background-color: rgb(217, 217, 217);
                    border-radius: 12px;
                    object-fit: cover;
                }

                .center-line {
                    width: 4px;
                    height: 318px;
                    background-color: rgb(35, 44, 223);
                    margin: 36px 78px;
                }

                .right-con {
                    width: 476px;

                    .title {
                        font-size: 36px;
                        font-weight: bolder;
                        margin: 0;
                        text-align: left;
                        font-family: 'BlackFont', sans-serif;
                    }

                    .line-warp {
                        display: flex;
                        align-items: center;
                        margin: 40px 0;


                        .yuan {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            background-color: rgb(41, 48, 242);
                        }

                        .line {
                            width: calc(100% - 20px);
                            height: 1px;
                            background: rgb(172, 172, 172);
                        }
                    }

                    .text {
                        font-size: 14px;
                        color: #000;
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }
}
</style>